import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';
import {
  buildListQueryParams,
  toBulkResolveBody,
  toCreateAndResolveBody,
  toQueueItem,
  toQueueListResponse,
  toResolveBody,
} from '../utils';

const BASE = `${PORTAL_API_BASE_URL}/api/admin/lms-resource-catalog`;

const req = (opts) => request({ ...opts, throw400Error: true });

export const fetchQueue = async (params) => {
  const qs = buildListQueryParams(params);
  const response = await req({ url: `${BASE}?${qs.toString()}`, method: 'GET' });
  return toQueueListResponse(response);
};

export const linkQueueItem = async (queueItemId, { resourceKey }) => {
  const body = toResolveBody({ resourceKey });
  const response = await req({
    url: `${BASE}/${encodeURIComponent(queueItemId)}/resolve`,
    method: 'POST',
    body: JSON.stringify(body),
  });
  return { queueItem: toQueueItem(response) };
};

export const createQueueResource = async (queueItemId, formBody) => {
  const body = toCreateAndResolveBody(formBody);
  const response = await req({
    url: `${BASE}/${encodeURIComponent(queueItemId)}/create-and-resolve`,
    method: 'POST',
    body: JSON.stringify(body),
  });
  return { queueItem: toQueueItem(response) };
};

/**
 * Bulk link queue items to resources using suggested matches.
 * @param {Array} linkableItems - Pending items with suggestedResource
 */
export const bulkResolveQueueItems = async (linkableItems) => {
  const body = toBulkResolveBody(linkableItems);
  const response = await req({
    url: `${BASE}/bulk-resolve`,
    method: 'POST',
    body: JSON.stringify(body),
  });
  return response;
};
